export const reduceFunc = (selected: number) => (prev: number, curr: number) =>
  Math.abs(curr - selected) < Math.abs(prev - selected) ? curr : prev;

type CreateArrayVars = {
  b2c: boolean;
  deposit: number;
  depositWithVat: number;
};

type CreateArraysDownPayment = (initalDownPayment: CreateArrayVars) => {
  downpaymentsWithVat: number[];
  downpaymentsWithoutVat: number[];
};

export const createArraysDownpayment: CreateArraysDownPayment = (
  initalDownPayment
) => {
  try {
    const downpaymentsWithoutVat: number[] = [];
    const downpaymentsWithVat: number[] = [];
    const { b2c, deposit, depositWithVat } = initalDownPayment;
    const vatPercentage = 22;

    if (b2c && depositWithVat) {
      for (let step = 0; step < depositWithVat; step += 100) {
        downpaymentsWithVat.push(step);
      }
      if (depositWithVat % 100 === 0) {
        downpaymentsWithVat.push(depositWithVat);
      }

      downpaymentsWithVat.forEach((value) => {
        downpaymentsWithoutVat.push(
          Number((value / (1 + vatPercentage / 100)).toFixed(2))
        );
      });
    }

    if (!b2c && deposit) {
      for (let step = 0; step < deposit; step += 100) {
        downpaymentsWithoutVat.push(step);
      }
      if (deposit % 100 === 0) {
        downpaymentsWithoutVat.push(deposit);
      }

      downpaymentsWithoutVat.forEach((value) => {
        downpaymentsWithVat.push(
          Number((value * (1 + vatPercentage / 100)).toFixed(2))
        );
      });
    }
    return { downpaymentsWithVat, downpaymentsWithoutVat };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error creating downpayment arrays', e);
    return { downpaymentsWithVat: [], downpaymentsWithoutVat: [] };
  }
};
